import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBars,
    faUser,
    faCaretDown,
    faCaretUp,
    faKey,
    faPowerOff,
} from "@fortawesome/free-solid-svg-icons";
import { Navbar, NavbarBrand } from 'reactstrap';
import { Popover, PopoverBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

//Helpers
import { getSessionCookie, removeAllCookies } from '../../helpers/cookies';
import { useAuth } from '../../context/auth';

export default function NavBarAdmin({ icon = null, brand, iconColor, userMenu }) {
    const { signOut } = useAuth();
    //Estado de controle para abrir o popover de sair do sistema e trocar senha
    const [openPopover, setOpenPopover] = useState(false);
    //Variavel de navegação
    const navigate = useNavigate();
    //Usuario logado no sistema
    const usuario = getSessionCookie();

    //Troca o estado do popover
    function togglePopover() {
        setOpenPopover(!openPopover);
    }

    return (

        <Navbar
            expand="md"
            className='navbar'
        >
            <div className='d-flex align-items-center justify-content-between w-100'>

                <div className='d-flex align-items-center justify-content-start align w-50 '>
                    {icon && <FontAwesomeIcon icon={icon} style={{ color: iconColor ? iconColor : "#fff" }} className="me-3" />}
                    {brand && <p style={{ color: iconColor ? iconColor : "#fff" }} className="m-0">{brand}</p>}
                </div>
                {userMenu
                    ?
                    <>
                        <div className='d-flex align-items-center justify-content-between'>
                            <span className='text-light me-3'>{usuario.nome}</span>
                            <div id="PopoverUserMenu" onClick={togglePopover}>
                                <FontAwesomeIcon icon={faUser} style={{ color: iconColor ? iconColor : "#fff" }} className="me-3" />
                                <FontAwesomeIcon icon={openPopover ? faCaretDown : faCaretUp} style={{ color: iconColor ? iconColor : "#fff" }} className="me-3" />
                            </div>
                        </div>

                        <Popover placement="bottom" isOpen={openPopover} target="PopoverUserMenu" toggle={togglePopover} className="popOverMenuUser">
                            <PopoverBody className='popOverBodyMenuUser shadow'>
                                <ul className='listUserMenu'>
                                    <li>
                                        <Link onClick={togglePopover} to="/admin/trocarsenha" >
                                            <FontAwesomeIcon icon={faKey} style={{ color: "#333" }} className="me-3" />
                                            Trocar Senha
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => signOut()} to="/auth/login" >
                                            <FontAwesomeIcon icon={faPowerOff} style={{ color: "#333" }} className="me-3" />
                                            Sair
                                        </Link>
                                    </li>
                                </ul>
                            </PopoverBody>
                        </Popover>
                    </>
                    : <></>
                }

            </div>
        </Navbar>
    )
}